import React, { ReactNode, useEffect, useState } from 'react'
import { Modal } from 'src/components/Modal/Modal'
import { useForm } from 'react-hook-form'
import { useMutation } from 'react-query'
import { ApiErrorType, DocumentType, ResponseType, ShipType } from 'src/types'
import { useTranslation } from 'react-i18next'
import { Button, InputField } from 'src/components/UI'
import { useDocuments } from '../../hooks'
import { toast } from 'react-toastify'
import { Post } from 'src/apis/apiWithType'
import { queryClient } from '../../../../../index'

interface ShipTypeMutateType { title: string, key: string, is_optional: boolean, type: DocumentType['type'] }

export const MutateDocument = ({ children, record, mode }: { children: ReactNode, record?: DocumentType, mode: 'edit' | 'add' }) => {


    const { t } = useTranslation()

    const [open, setOpen] = useState<boolean>(false)

    const { refetch } = useDocuments()

    const { register, formState: { errors }, reset, handleSubmit, setValue, getValues, watch } = useForm<DocumentType>()

    const { mutate, isLoading } = useMutation<ResponseType<ShipType[]>, ApiErrorType, Partial<DocumentType>>({
        mutationFn: (data) => record?.id ? Post(`/basic-information/documents/update/${record.id}`, { ...data, form: "update_form" }) as any : Post('/basic-information/documents/store', { ...data, form: "store_form" }),
        mutationKey: ['SingleShipType', record?.id ?? 'Create'],
        onSuccess: (suc) => {
            toast.success(t('AddedSuccessfully'))
            setOpen(false)
            refetch()
            queryClient.invalidateQueries({ queryKey: ['GetCrewDoc'] })
        },
        onError: (error) => {
            toast.error(error.data.message)
        }
    })



    useEffect(() => {
        if (record) {
            const { is_optional, title, type, key, is_creditable } = record
            reset({ key, is_optional, title, type, is_creditable })
        }
    }, [record])

    useEffect(() => {
        if (mode == 'add')
            reset()
    }, [open])



    const handleMutateDocument = (data: Partial<DocumentType>) => {
        mutate({ ...data, is_creditable: data.is_creditable ? 1 : 0 })

    }


    return (
        <>
            <div className='flex ' onClick={() => setOpen(true)}>
                {children}
            </div>

            <Modal open={open} setOpen={setOpen} title={record?.id ? t('EditDocument') : t('AddDocument')}>

                <form className='flex flex-col gap-4 min-w-64' onSubmit={handleSubmit(handleMutateDocument)}>
                    <InputField
                        label={t('Title')}
                        {...register('title', { required: true })}
                    />

                    <InputField
                        label={t('key')}
                        {...register('key', { required: true })}

                    />

                    <div className='flex flex-col gap-2 '>
                        <span className='text-gray-500'>{t('DocType')}</span>

                        <select   {...register('type', { required: { value: true, message: t('DocTypeIsRequired') } })} className='rounded-lg'>
                            <option value={'VISA'}>{t('visa')}</option>
                            <option value={'CREW'}>{t('crew')}</option>
                        </select>

                        <label className='flex flex-row gap-3 items-center text-sm text-gray-500'>
                            <span> {t('Creditable')}</span>
                            <input type='checkbox' className='rounded' {...register('is_creditable')} />
                        </label>

                        <label className='flex flex-row gap-3 items-center text-sm text-gray-500'>
                            <span> {t('IsOptional')}</span>
                            <input type='checkbox' className='rounded' {...register('is_optional')} />
                        </label>


                        {!!errors?.type && <span className='text-sm text-red-500'>{errors.type?.message}</span>}
                    </div>




                    <Button loading={isLoading} keyTitle='save' type='submit' ></Button>



                </form>

            </Modal>
        </>
    )
}
